import * as Print from 'expo-print';
import { ajusterUnePage, type ResultatUnePage } from './cvUnePage';
import type { CvMeta } from './pdf';
import type { GeneratedCv } from '../types';

/**
 * PDF du CV, ajusté sur UNE page A4 (`cvUnePage.ts`). Le nombre de pages est celui que rend
 * `expo-print` pour le fichier même qui sera partagé. Étape locale et gratuite, avant le gating.
 */
export async function genererCvPdfUnePage(
  cv: GeneratedCv,
  meta: CvMeta,
  condenser?: (cv: GeneratedCv) => Promise<GeneratedCv | null>,
): Promise<ResultatUnePage> {
  return ajusterUnePage(cv, meta, {
    imprimer: async (html) => {
      const { uri, numberOfPages } = await Print.printToFileAsync({ html });
      return { uri, numberOfPages };
    },
    condenser,
  });
}
